import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import VentasMiembros from "../components/administrador/adheridos/ventas_miembros";
import ImportacionesProduccion from "../components/administrador/adheridos/importaciones_produccion";
import ImportacionesSubpartida from "../components/administrador/adheridos/importaciones_subpartida";
import "../styles/administrador.css";

const Adheridos = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [mesSeleccionado, setMesSeleccionado] = useState(0);
  const [token, setToken] = useState(null);
  const [idAdministrador, setIdAdministrador] = useState(null);
  const location = useLocation();

  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 2018 + 1 },
    (_, i) => currentYear - i
  );
  const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenFromUrl = params.get("token");
    const idFromUrl = params.get("idAdministrador");

    if (tokenFromUrl) {
      setToken(tokenFromUrl);
    }
    if (idFromUrl) {
      setIdAdministrador(parseInt(idFromUrl, 10));
    }
  }, [location.search]);

  return (
    <div className="dashboard-container">
      <div className="select-mes">
        <div className="select-row">
          <div className="select-item">
            <label>Año:</label>
            <select
              value={year}
              onChange={(e) => setYear(Number(e.target.value))}
            >
              {years.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>
          <div className="select-item">
            <label>Mes:</label>
            <select
              value={mesSeleccionado}
              onChange={(e) =>
                setMesSeleccionado(
                  e.target.value === "acumulado" ? 0 : Number(e.target.value)
                )
              }
            >
              <option value="acumulado">Acumulado</option>
              {meses.map((m, index) => (
                <option key={index} value={index + 1}>
                  {m}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="container-graficas">
        <VentasMiembros
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
        />
        <ImportacionesProduccion
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
        />
        <ImportacionesSubpartida
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
        />
      </div>
    </div>
  );
};

export default Adheridos;
